import styled from 'styled-components'

const StyledStatistics = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export { StyledStatistics }
